export default __webpack_public_path__ + "static/media/Insert_CommentaryField.623aab61.svg";